import React, { useState } from 'react';

function CustomerAdd({ onCustomerAdded, userId }) {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('https://www.kenan.bybello.com/backend/api/customers.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name.toLocaleUpperCase('tr-TR'), user_id: userId })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage('Müşteri başarıyla eklendi!');
          setName('');
          if (onCustomerAdded) onCustomerAdded();
        } else {
          setMessage(data.error || 'Bir hata oluştu.');
        }
      })
      .catch(() => setMessage('Bir hata oluştu.'));
  };

  return (
    <div>
      <h2>Yeni Müşteri Ekle</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Şirket Adı"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Ekle</button>
      </form>
      {message && <div>{message}</div>}
    </div>
  );
}

export default CustomerAdd;
